import React from 'react';
import { BodyRegular, BodyVerySmall } from "../../atoms/fonts/Body";
import Colours from "../../atoms/Colours";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { DROP_DOWN_STYLES, groupStyles, PORTAL_DROP_DOWN_STYLES } from "./DropDownStyles";
import makeAnimated from "react-select/animated";

export interface DropDownListItem {
  value: any;
  label: string;
}

const animatedComponents: any = makeAnimated();

function formatOptionLabel(data: any) {
  return (<div {...data} style={groupStyles}>
    <BodyRegular weight={400} colour={Colours.black}>{data.label}</BodyRegular>
    {data.value.memberCount && <BodyVerySmall weight={400} className={'memberCount'}
                                              colour={Colours.black}>{data.value.memberCount}</BodyVerySmall>}
  </div>)
};

export function ReactSelectDropDownList(props: Props) {
  const {onItemSelected, items,   disabled, className, selectedItem, placeholder, portalMenu} = props;
  const {t} = useTranslation();


  return (
    <Select
      className={className ?? ''}
      value={selectedItem}
      options={items}
      formatOptionLabel={formatOptionLabel}
      onChange={onItemSelected}
      styles={portalMenu ? PORTAL_DROP_DOWN_STYLES : DROP_DOWN_STYLES}
      menuPortalTarget={portalMenu ? document.body : undefined}
      isDisabled={disabled}
      placeholder={t(placeholder ?? 'Select...')}
      closeMenuOnSelect={true}
      components={{ ...animatedComponents, ClearIndicator:() => null, IndicatorSeparator:() => null }}
    />
  )
}

interface Props {
  disabled?: boolean;
  className?: string;
  selectedItem?: any;
  onItemSelected: (selection: any) => void;
  items: DropDownListItem[];
  placeholder?: string;
  /** Render the menu into the body, for a dropdown inside a dialog or other clipping container. */
  portalMenu?: boolean;
}
